import React from "react";
import chevron from "../../../../../../assets/icons/down-arrow.svg";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import get from "lodash/get";
import "./dropdown.m.css";

export const PlanDropdown = ({
  group = {},
  initialPlan,
  currentPlan,
  selectedSubscriptions,
  setSelectedSubscriptions,
  mode,
  toggleDropdown,
  activeDropdown,
}) => {
  const { subscription_plans: plans = [], id: groupId } = group;

  const handlePlanChange = (group, planIndex, groupId) => {
    const currentPlan = get(group, ["subscription_plans", planIndex], {});
    setSelectedSubscriptions({ ...selectedSubscriptions, [groupId]: currentPlan });
    toggleDropdown(groupId);
  };
  const updatedStyle = mode === "dark" ? `wrapper dark` : "wrapper";
  const singlePlan = plans.length <= 1;
  const selectedPlan = currentPlan?.title || initialPlan?.title;

  return (
    <div styleName={updatedStyle} className={activeDropdown === group.id ? "transform" : "hidden"}>
      <div
        styleName="overlay"
        style={singlePlan ? { cursor: "not-allowed" } : {}}
        data-test-id="selected-plan"
        onClick={() => toggleDropdown(group.id)}
      >
        {selectedPlan}
        <span styleName="chevron">
          {!singlePlan ? <SvgHandler xlinkHref={chevron} width="24" height="24" /> : <></>}
        </span>
      </div>
      {!singlePlan ? (
        <div styleName="container" data-test-id="dropdown">
          {plans.map((plan, index) => (
            <div
              styleName="plan"
              key={plan?.id}
              data-test-id={`dropdown-${index}`}
              onClick={() => handlePlanChange(group, index, groupId)}
            >
              {plan?.title}
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
